import { render, staticRenderFns } from "./FacebookIcon.vue?vue&type=template&id=3422f438&scoped=true"
import script from "./FacebookIcon.vue?vue&type=script&lang=ts"
export * from "./FacebookIcon.vue?vue&type=script&lang=ts"
import style0 from "./FacebookIcon.vue?vue&type=style&index=0&id=3422f438&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3422f438",
  null
  
)

export default component.exports